import { createIcon } from '../icon'
import FacebookCircleIcon from '../svg/FacebookCircleIcon'

export const FacebookCircleIconDefault = createIcon(FacebookCircleIcon)
